import { ApiRequestFactory } from '@/api/api-requests-factory/request-factory';

import { AxiosRequestConfig, AxiosResponse } from 'axios';
import { Interceptors } from '@/api/api-requests-factory/models/interceptors.model';

export { RequestPerformer } from '@/api/api-requests-factory/request-performer';
export { ApiResourceMethod } from '@/api/api-requests-factory/resource-method';
export { HttpMethods } from '@/api/api-requests-factory/models/methods.model';
export { ApiMethodPerformer } from '@/api/api-requests-factory/method-performer';

export type PerformerInterceptors = {
  request?: Interceptors<AxiosRequestConfig>;
  response?: Interceptors<AxiosResponse>;
}

export const apiRequestFactory = new ApiRequestFactory();
